import Grid from '@mui/material/Grid'

import Customer from 'layouts/feedback/customer/components/Customer'
import Details from 'layouts/feedback/customer/components/Details'

function MainForm() {
	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Details />
			</Grid>
			<Grid item xs={12}>
				<Customer />
			</Grid>
		</Grid>
	)
}

export default MainForm
